import axios from "axios";
import { baseUrl } from "./baseUrl";

// App Configs API
const api = axios.create({
    baseURL: `${baseUrl}/admin/configs`,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

// Add request interceptor to include auth token
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Create new config
export const createConfig = async (configData) => {
    try {
        const response = await api.post("/configs", configData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Get all configs with optional filters
export const getAllConfigs = async (filters = {}) => {
    try {
        const params = new URLSearchParams();
        if (filters.key) params.append('key', filters.key);
        if (filters.type) params.append('type', filters.type);
        if (filters.search) params.append('search', filters.search);
        
        const response = await api.get(`/configs?${params.toString()}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Get config by ID
export const getConfigById = async (id) => {
    try {
        const response = await api.get(`/configs/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Update config
export const updateConfig = async ({ id, ...configData }) => {
    try {
        const response = await api.put(`/configs/${id}`, configData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Delete config
export const deleteConfig = async (id) => {
    try {
        const response = await api.delete(`/configs/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};
